import { LOGIN_PATH, SESSION_STORAGE_KEY } from '../constant/Constant';
import SessionStorageUtil from './SessionStorageUtil';

class AuthenticationUtil {
    static getOrLogin() {
        var authentication = SessionStorageUtil.get(SESSION_STORAGE_KEY.AUTHENTICATION);
        if (authentication == null) {
            alert('로그인 정보가 없습니다. 로그인 화면으로 이동됩니다.');
            window.history.pushState({}, '', LOGIN_PATH);
            window.location.reload();
        } else {
            return authentication;
        }
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.AUTHENTICATION);
    }

    static get() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.AUTHENTICATION);
    }

    static isLogin() {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return false;
        } else {
            return true;
        }
    }

    static getUserId() {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return '';
        } else {
            return authentication.userId;
        }
    }

    static getUserNm() {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return '';
        } else {
            return authentication.userNm;
        }
    }

    static setUserNm(userNm) {
        var authentication = AuthenticationUtil.get();
        if (authentication !== null && authentication !== undefined) {
            return AuthenticationUtil.set({ ...authentication, userNm });
        }
    }

    static getUserRoleCd() {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return '';
        } else {
            return authentication.userRoleCd;
        }
    }

    static getUserUniversityCd() {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return '';
        } else {
            return authentication.userUniversityCd;
        }
    }

    static setUserUniversityCd(userUniversityCd) {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return '';
        } else {
            return AuthenticationUtil.set({ ...authentication, userUniversityCd });
        }
    }

    static getUserUniversityNm() {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return '';
        } else {
            return authentication.userUniversityNm;
        }
    }

    static setUserUniversityNm(userUniversityNm) {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return '';
        } else {
            return AuthenticationUtil.set({ ...authentication, userUniversityNm });
        }
    }

    static getPrevUserNm() {
        var authentication = AuthenticationUtil.get();
        if (authentication === null || authentication === undefined) {
            return '';
        } else {
            return authentication.prevUserNm;
        }
    }

    static set(authentication) {
        SessionStorageUtil.set(SESSION_STORAGE_KEY.AUTHENTICATION, authentication);
    }

    static clear() {
        SessionStorageUtil.set(SESSION_STORAGE_KEY.AUTHENTICATION, null);
    }
}

export default AuthenticationUtil;
